import Vue from 'vue'
import Vuex from 'vuex'
import { injectState } from '@common/appState'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    locale: '',
    eventLocale: '',
    permissions: {
      global: [],
      account: [],
      event: []
    },
    routeName: '',
    routeParameters: {},
    config: {
      app: {
        baseUrl: ''
      },
      platform: {
        baseUrl: ''
      },
      googleAnalytics: {
        key: ''
      },
      googleMaps: {
        key: ''
      },
      bugsnag: {
        key: ''
      },
      pusher: {
        key: '',
        cluster: ''
      }
    },
    attendee: {},
    formFields: [],
    isPublicTimeline: false
  },

  mutations: {
    SET_LOCALE (state, locale) {
      state.locale = locale
    },
    SET_EVENT_LOCALE (state, eventLocale) {
      state.eventLocale = eventLocale
    },
    SET_PERMISSIONS (state, permissions) {
      state.permissions = {
        global: permissions.global,
        account: permissions.account,
        event: permissions.event
      }
    },
    SET_ROUTE_NAME (state, routeName) {
      state.routeName = routeName
    },
    SET_ROUTE_PARAMETERS (state, routeParameters) {
      state.routeParameters = routeParameters
    },
    SET_CONFIG (state, config) {
      state.config = config
    },
    SET_ATTENDEE (state, attendee) {
      state.attendee = attendee
    },
    SET_FORM_FIELDS (state, formFields) {
      state.formFields = formFields
    },
    SET_PUBLIC_TIMELINE (state, isPublicTimeline) {
      state.isPublicTimeline = isPublicTimeline
    }
  },

  actions: {
    storeAttendee ({ commit, state }, attendee) {
      commit('SET_ATTENDEE', attendee)
    },
    storeFormFields ({ commit, state }, formFields) {
      commit('SET_FORM_FIELDS', formFields)
    },
    saveIsPublicTimeline ({ commit, state }, isPublicTimeline) {
      commit('SET_PUBLIC_TIMELINE', isPublicTimeline)
    }
  }
})

injectState(store)

export default store
